<template>
  <b-modal
    v-model="modalShow"
    :title="$t('userlist')"
    size="sm"
    @hidden="clearModal"
  >
    <div
      v-if="employee"
      class="modal-content"
    >
      <div class="form-section">
        <h4 class="section-title">
          {{ $t('employeeinfo') }}
        </h4>

        <div class="employee-info">
          <div class="image-container">
            <img
              v-if="employee.imageUrl"
              :src="employee.imageUrl"
              alt="Employee Image"
              class="employee-image"
            >
            <span v-else>{{ $t('noimage') }}</span>
          </div>

          <div class="info-item">
            <strong>{{ $t('workerid') }} : </strong> {{ employee.empid }}
          </div>
          <div class="info-item">
            <strong>{{ $t('fullname') }} : </strong> {{ employee.username }}
          </div>
          <div class="info-item">
            <strong>{{ $t('email') }} : </strong> {{ employee.email }}
          </div>
          <div class="info-item">
            <strong>{{ $t('phone') }} : </strong> {{ employee.phone }}
          </div>
          <div class="info-item">
            <strong>{{ $t('deptname') }} : </strong> {{ employee.dept }}
          </div>
          <div class="info-item">
            <strong>{{ $t('jobtitle') }} : </strong> {{ employee.jobtitle ? employee.jobtitle.titleName : '' }}
          </div>
          <div class="info-item">
            <strong>{{ $t('role') }} : </strong>
            <span
              v-for="role in employee.roles"
              :key="role.id"
            >{{ role.name }}<br></span>
          </div>
          <div class="info-item">
            <strong>{{ $t('status') }} : </strong>
            <span :class="{'text-danger': !employee.isEnabled, 'text-dark': employee.isEnabled}">
              {{ employee.isEnabled ? $t('active') : $t('nonactive') }}
            </span>
          </div>
          <div class="info-item">
            <strong>{{ $t('signature') }} : </strong>
            <div class="image-container">
              <img
                v-if="employee.signature"
                :src="employee.signature"
                alt="Signature"
                class="employee-signature"
              >
              <span v-else>{{ $t('noimage') }}</span>
            </div>
          </div>
        </div>

        <b-button
          :class="employee.isEnabled ? 'btn-danger' : 'btn btn-success'"
          class="toggle-button"
          @click="confirmstatus(employee)"
        >
          {{ employee.isEnabled ? $t('nonactive') : $t('enable') }}
        </b-button>
      </div>
      <!--model confirm-->
      <b-modal
        v-model="showconfirmstatusModal"
        :title="$t('confirm')"
        :ok-title="$t('yes')"
        :cancel-title="$t('cancel')"
        @ok="toggleStatus"
      >
        <p class="my-4">
          {{ $t('confirmdetails') }}
        </p>
      </b-modal>
    </div>
    <div v-else>
      <p>{{ $t('nonuserdetails') }}</p>
    </div>

    <template #modal-footer>
      <b-button
        variant="dark"
        @click="modalShow = false"
      >
        {{ $t('close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import apiSetting from '@/services/Setting'

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: this.show,
      showconfirmstatusModal: false,
      employeeData: '',
    }
  },
  watch: {
    show(newVal) {
      this.modalShow = newVal
    },
    modalShow(newVal) {
      if (!newVal) {
        this.clearModal()
      }
    },
  },
  methods: {
    clearModal() {
      this.$emit('close')
    },
    confirmstatus(employee) {
      this.employeeData = employee
      this.showconfirmstatusModal = true
    },

    async toggleStatus() {
      const employee = this.employeeData
      const originalState = employee.isEnabled
      const action = employee.isEnabled ? 'disable' : 'enable'

      try {
        await apiSetting.put(`check/${employee.id}/${action}`)
        employee.isEnabled = !employee.isEnabled
        this.showconfirmstatusModal = false
      } catch (error) {
        console.error('Error toggling employee status:', error)
        employee.isEnabled = originalState
        this.showconfirmstatusModal = false
      }
    },
  },
}
</script>

  <style scoped>
  .employee-image {
    width: 200px;
    height: 200px;
    border: 1px solid black; /* กรอบสีดำขนาด 1px */
    margin-bottom: 0.5rem;
  }

  .modal-content {
    padding: 1rem;
  }

  .form-section {
    margin-bottom: 1rem;
  }

  .section-title {
    text-align: center;
    margin-bottom: 1rem;
    font-weight: bold;
  }

  .employee-info {
    display: flex;
    flex-direction: column;
    align-items: left;
    font-size: 16px;
  }

  .info-item {
    margin-bottom: 0.5rem;
  }

  .image-container {
    display: inline-block;
    text-align: center;
    margin-bottom: 3rem;
  }

  .toggle-button {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .text-danger {
    color: red;
  }
  .text-dark {
    color: black;
  }
  </style>
